var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home-container"},[_c('Loader',{attrs:{"is-loading":_vm.isLoading}}),(!_vm.isLoading)?_c('NoTeamMessage'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }